<!--Renders only when Overall chart data is available -->
<ng-container *ngIf="isChartDataAvailable">
  <mat-card class="container-nps">
    <mat-card-header class="nps-overall-chart-header">
      <mat-card-title class="nps-overall-chart-title">
        {{ 'NPS_OVERALL_CHART.NAME' | translate }}
      </mat-card-title>
      <div class="nps-tool-tip">
        <div [glxyPopover]="popover" (mouseenter)="showPopovers()" (mouseleave)="hidePopovers()">
          <mat-icon class="info-icon">info_outline</mat-icon>
        </div>
        <glxy-popover
          #popover
          [isOpen]="showPopover"
          [maxWidth]="'400px'"
          [positions]="[PopoverPositions.Bottom, PopoverPositions.BottomRight]"
        >
          <div [innerHTML]="'NPS_OVERALL_CHART.NPS_INFO' | translate"></div>
        </glxy-popover>
      </div>
    </mat-card-header>
    <mat-card-content class="nps-card-content">
      <div class="npschart">
        <div class="score-container">
          <reviews-statistic-delta [value]="currentScore" [delta]="difference" [alignDeltaCenter]="true">
          </reviews-statistic-delta>
          <div class="total-rating">
            {{
              'NPS_OVERALL_CHART.RATINGS'
                | translate
                  : {
                      totalScore: totalNPSRatings,
                    }
            }}
          </div>
        </div>
        <ng-container *ngIf="chartOptions$ | async as chartoptions">
          <div class="overall-chart-content">
            <apx-chart
              [series]="chartoptions.series"
              [chart]="chartoptions.chart"
              [dataLabels]="chartoptions.dataLabels"
              [tooltip]="chartoptions.tooltip"
              [legend]="chartoptions.legend"
              [xaxis]="chartoptions.xaxis"
              [yaxis]="chartoptions.yaxis"
              [grid]="chartoptions.grid"
              [plotOptions]="chartoptions.plotOptions"
              [colors]="chartoptions.color"
            >
            </apx-chart>
          </div>
        </ng-container>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>
